import * as React from "react";
import LabelImportantIcon from "@mui/icons-material/LabelImportant";
import { useNavigate } from "react-router-dom";
import { Message } from "../../Interface/Message";
import {
  Box,
  Button,
  Checkbox,
  Container,
  CssBaseline,
  FormControlLabel,
  Grid,
  List,
  ListItem,
  ListItemText,
  Stack,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import AppHelper from "../../Helper/AppHelper";
import Loader from "../Loader";
import AlertBox from "../CommonComponent/AlertBox";
import { AppSettings } from "../../AppSettings";
import { Role } from "../../Interface/Role";
import { Service } from "../../Interface/Service";
import DisplaySettingsIcon from "@mui/icons-material/DisplaySettings";
export default function CreateEditRole() {
  const [serviceChecked, setServiceChecked] = React.useState([""]);
  const [isUpdateForm, setUpdateForm] = React.useState(false);
  const [roleInfo, setRole] = React.useState<Role>({
    id: 0,
    name: "",
    description: "",
    isActive: true,
    services: [
      {
        id: 0,
        name: "",
        description: "",
        serviceSSOLink: "",
        iconName: "",
        priority: "0",
        imageSrc: "",
        imageFile: null,
        isActive: true,
        isAdminActive: true,
      },
    ],
  });

  const [services, setServiceList] = React.useState<Service[]>([]);

  const [isChecked, setIsChecked] = React.useState(true);
  const [openLoader, setOpenloader] = React.useState(false);

  const [formValidation, setformValidation] = React.useState({
    name: false,
    description: false,
  });

  const [alertBoxmsg, setAlertBoxmsg] = React.useState<Message>({
    Type: "",
    Text: "",
  });

  const handleCheckboxChange = (event: {
    target: { checked: boolean | ((prevState: boolean) => boolean) };
  }) => {
    setIsChecked(event.target.checked);
  };

  const handleInputChange = (
    e:
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      | (Event & { target: { value: string; id: string } })
  ) => {
    const { id, value } = e.target;

    setRole({ ...roleInfo, [id]: value });
    isValidForm(id, value);
  };

  function isValidForm(itemID: string, value: string) {
    console.log(roleInfo.name, roleInfo.description);

    let validate = {
      name: AppHelper.isNullorEmpty(roleInfo.name),
      description: AppHelper.isNullorEmpty(roleInfo.description),
    };

    setformValidation(validate);

    if (validate.name || validate.description) {
      return false;
    }
    return true;
  }

  const handleSubmit = () => {
    let msg: Message = { Text: "", Type: "" };

    if (isValidForm("", "")) {
      setOpenloader(true);

      let apiUrl = AppSettings.API_URL + "Role/AddRole";

      if (isUpdateForm) {
        apiUrl = AppSettings.API_URL + "Role/UpdateRole";
      }

      var userServices: Service[] = [];
      var arrayLength = serviceChecked.length;
      for (var i = 0; i < arrayLength; i++) {
        var y: number = +serviceChecked[i];
        if (y != 0) {
          userServices.push({
            id: y,
            name: "string",
            description: "string",
            serviceSSOLink: "",
            iconName: "",
            priority: "0",
            imageSrc: "",
            imageFile: null,
            isActive: true,
            isAdminActive: true,
          });
        }
      }

      if (userServices.length == 0) {
        let msg: Message = {
          Text: "Please select a Service.",
          Type: "Error",
        };
        setAlertBoxmsg(msg);
        setOpenloader(false);
        return;
      }

      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + AppHelper.getUser().token,
        },
        body: JSON.stringify({
          id: roleInfo.id,
          name: roleInfo.name,
          description: roleInfo.description,
          isActive: isChecked,
          services: userServices,
          createdBy: AppHelper.getUser().id.toString(),
        }),
      };

      fetch(apiUrl, requestOptions)
        .then((response) => {
          console.log(response);
          if (!response.ok) {
            if (response.status == 401) navigate("/SessionExpired");
            else
              throw new Error(
                `API Error, This is an HTTP error: The status is ${response.status}`
              );
          }
          return response.json();
        })
        .then(
          (data) => {
            if (data) {
              if (data.successes.length > 0) {
                if (isUpdateForm) {
                  navigate("/RoleList?msg=Update_Successful");
                } else {
                  navigate("/RoleList?msg=Create_Successful");
                }
              } else {
                msg = { Text: data.errors[0], Type: "Error" };
                setAlertBoxmsg(msg);
              }
            }

            setOpenloader(false);
          },
          (error) => {
            setOpenloader(false);
            // let msg: Message = {
            //   Text: "Something went wrong please try again.",
            //   Type: "Error",
            // };
            // setAlertBoxmsg(msg);
            console.log("API Error: " + apiUrl + " " + error);
            navigate("/SessionExpired");
          }
        )
        .catch((err) => {
          if (err.message === "Failed to fetch") {
            navigate("/SessionExpired");
          } else {
            //API Error.
            let msgError: Message = {
              Text: err.message,
              Type: "Error",
            };
            setAlertBoxmsg(msgError);
          }
        })
        .finally(() => {
          setOpenloader(false);
        });
    }
  };

  const handleServiceToggle = (s: Service) => () => {
    let id = s.id || "";
    let value = `${id}`;
    const currentIndex = serviceChecked.indexOf(value);
    const newChecked = [...serviceChecked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setServiceChecked(newChecked);
  };

  function getServiceID(s: Service) {
    let id = s.id || "";
    let value = `${id}`;
    return value;
  }

  const navigate = useNavigate();

  function getServices(query: string) {
    let userType=AppHelper.getUser().userType.toString();
    let apiUrl = AppSettings.API_URL + "Service/GetAllServicesForRoles?IsAdmin=" + userType;
    fetch(apiUrl, AppHelper.requestOptions("POST"))
      .then((response) => {
        console.log(response);
        if (!response.ok) {
          if (response.status == 401) navigate("/SessionExpired");
          else
            throw new Error(
              `API Error, This is an HTTP error: The status is ${response.status}`
            );
        }
        return response.json();
      })
      .then((data) => {
        if (data !== undefined) {
          let serivces: Service[] = data || " ";
          let activeSerivces = serivces.filter((x) => x.isActive === true);
          setServiceList(activeSerivces);
        }
      })
      .catch((err) => {
        if (err.message === "Failed to fetch") {
          navigate("/SessionExpired");
        } else {
          console.log(err.message);
        }
      })
      .finally(() => {
        if (query === "") setOpenloader(false);
      });
  }

  const effectCount = React.useRef(true);
  React.useEffect(() => {
        if(AppHelper.getUser().userType ==="Admin")
    {
    AppHelper.isAdminUser();
    }else
    if(AppHelper.getUser().userType ==="Super Admin")
    {
    AppHelper.isSuperAdminUser();
    }
    if (effectCount.current) {
      effectCount.current = false;
    }
    setOpenloader(true);
    let msg: Message = { Text: "", Type: "" };
    let apiUrl = "";
    let query = AppHelper.getQueryValue().get("id");

    getServices(query || "");

    if (query === null) {
      setUpdateForm(false);
      return;
    }
    if (query !== undefined || query !== "" || query !== null) {
      setOpenloader(true);
      setUpdateForm(true);
      apiUrl = AppSettings.API_URL + "Role/GetRoleByID?id=" + query;
      fetch(apiUrl, AppHelper.requestOptions("POST"))
        .then((response) => {
          console.log(response);
          if (!response.ok) {
            if (response.status == 401) navigate("/SessionExpired");
            else
              throw new Error(
                `API Error, This is an HTTP error: The status is ${response.status}`
              );
          }
          return response.json();
        })
        .then((data) => {
          if (data !== undefined) {
            setRole(data);
            let role: Role = data || " ";
            bindUserRoles(role);
          }
        })
        .catch((err) => {
          if (err.message === "Failed to fetch") {
            navigate("/SessionExpired");
          } else {
            msg = { Text: err.message, Type: "Error" };
            setAlertBoxmsg(msg);
          }
        })
        .finally(() => {
          setOpenloader(false);
        });
    }
  }, []);

  function bindUserRoles(role: Role) {
    const newChecked = [""];
    if (role.name != "" && role.services != null) {
      role.services.map((s) => {
        let id = s.id || "";
        let value = `${id}`;
        if (!newChecked.includes(value)) {
          newChecked.push(value);
        }
      });
      setServiceChecked(newChecked);
      setIsChecked(role.isActive || false);
    }
  }

  return (
    <div className="page-container">
      <div className="add-details">
        <Loader value={openLoader}></Loader>
          <Container component="main" maxWidth="md">
            <CssBaseline />
            <Box
              sx={{
                marginTop: 3,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography
                component="h1"
                variant="h5"
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <DisplaySettingsIcon sx={{ fontSize: 30, marginRight: 1 }} />
                <b>{isUpdateForm ? "Update Role" : "Add Role"}</b>
              </Typography>

              {alertBoxmsg.Text !== "" && (
                <AlertBox value={alertBoxmsg}></AlertBox>
              )}
              <Box component="form" noValidate sx={{ mt: 3 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    {" "}
                    <TextField
                      id="name"
                      label="Role Name"
                      multiline
                      fullWidth
                      maxRows={4}
                      value={roleInfo.name}
                      onChange={(e) => handleInputChange(e)}
                      error={formValidation.name}
                      helperText={
                        formValidation.name ? "Error : Field is required" : ""
                      }
                    />
                  </Grid>
                  <Grid item xs={12}>
                    {" "}
                    <TextField
                      id="description"
                      label="Description"
                      multiline
                      fullWidth
                      rows={2}
                      value={roleInfo.description}
                      onChange={(e) => handleInputChange(e)}
                      error={formValidation.description}
                      helperText={
                        formValidation.description
                          ? "Error : Field is required"
                          : ""
                      }
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Stack
                      spacing={8}
                      pt={0}
                      direction="row"
                      className="MuiTextField-root"
                    >
                      <Typography variant="h6" component="div">
                        <b> Services</b>
                      </Typography>
                    </Stack>
                    <Stack direction="row">
                      <div
                        style={{
                          width: "100%",
                          height: "10%",
                          overflow: "auto",
                          backgroundColor: "#F2F2F2",
                          borderRadius: "10px",
                        }}
                      >
                        {
                          <List
                            sx={{
                              width: "100%",
                              height: "340px",
                            }}
                          >
                            {services.map((s) => (
                              <ListItem>
                                <img
                                  alt=""
                                  src={s.imageSrc}
                                  className="role-service-icon"
                                />{" "}
                                <ListItemText id={s.name} primary={s.name} />
                                <Switch
                                  edge="end"
                                  onChange={handleServiceToggle(s)}
                                  checked={
                                    serviceChecked.indexOf(getServiceID(s)) !==
                                    -1
                                  }
                                  inputProps={{
                                    "aria-labelledby": "switch-list-label-wifi",
                                  }}
                                />
                              </ListItem>
                            ))}
                          </List>
                        }
                      </div>
                    </Stack>
                  </Grid>
                  <Stack spacing={2} padding={2} direction="row">
                    <FormControlLabel
                      className="chekcBox"
                      control={
                        <Checkbox
                          checked={isChecked}
                          onChange={handleCheckboxChange}
                          name="isActive"
                          id="isActive"
                        />
                      }
                      label="Enabled"
                    />
                    <Button
                      variant="contained"
                      size="large"
                      startIcon={<LabelImportantIcon />}
                      onClick={() => handleSubmit()}
                    >
                      Submit
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={() => navigate("/RoleList")}
                    >
                      Cancel
                    </Button>
                  </Stack>
                </Grid>
              </Box>
            </Box>
          </Container>
      </div>
    </div>
  );
}
